var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { class: { main__login: _vm.auth } }, [
    _vm.auth
      ? _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "main-check-ul" }, [
            _c("h2", [_vm._v("Проверка ЮЛ / ИП")]),
            _vm._v(" "),
            _c("div", { staticClass: "main-check-ul__search" }, [
              _vm.hasAccessToUlCheck
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.input,
                        expression: "input",
                        modifiers: { trim: true },
                      },
                    ],
                    attrs: {
                      type: "text",
                      placeholder:
                        "ЮРЛ Леонид Грозный, Риск ИКС, ООО «Новострой» Гарматная ул...",
                    },
                    domProps: { value: _vm.input },
                    on: {
                      keydown: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            $event.keyCode !== 40
                          ) {
                            return null
                          }
                          return _vm.arrowHandler.apply(null, arguments)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            $event.keyCode !== 38
                          ) {
                            return null
                          }
                          return _vm.arrowHandler.apply(null, arguments)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            $event.keyCode !== 13
                          ) {
                            return null
                          }
                          return _vm.openSelected.apply(null, arguments)
                        },
                      ],
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.input = $event.target.value.trim()
                        },
                        _vm.timeoutRequest,
                      ],
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  })
                : _c("input", {
                    attrs: {
                      type: "text",
                      placeholder:
                        "ЮРЛ Леонид Грозный, Риск ИКС, ООО «Новострой» Гарматная ул...",
                      disabled: "",
                    },
                  }),
              _vm._v(" "),
              _vm.hasAccessToUlCheck
                ? _c("button", { on: { click: _vm.findHandler } }, [
                    _vm._v("НАЙТИ"),
                  ])
                : _c("button", { staticStyle: { cursor: "not-allowed" } }, [
                    _vm._v("НАЙТИ"),
                  ]),
              _vm._v(" "),
              _vm.input
                ? _c("span", {
                    staticClass: "lnr lnr-cross",
                    on: { click: _vm.resetSearch },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.searchLength
              ? _c(
                  "div",
                  { staticClass: "main-check-ul__search-results" },
                  _vm._l(_vm.search, function (e, i) {
                    return _c(
                      "div",
                      {
                        key: i,
                        ref: "search-items",
                        refInFor: true,
                        attrs: { "data-ogrn": e.ogrn },
                        on: {
                          click: function ($event) {
                            return _vm.clickSearchItem(e.ogrn)
                          },
                        },
                      },
                      [
                        _c("span", [_vm._v(_vm._s(e.value))]),
                        _vm._v(" "),
                        e.management
                          ? _c("div", { staticClass: "fz12" }, [
                              _c("b", [
                                _vm._v(_vm._s(e.management.post) + ": "),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(e.management.name))]),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "main-separator" }),
          _vm._v(" "),
          _c("div", { staticClass: "main-check" }, [
            _c(
              "a",
              {
                class: {
                  "main-check-block": true,
                  disabled: !_vm.hasAccessToVisitorCheck,
                },
                attrs: {
                  href: _vm.hasAccessToVisitorCheck ? "/visitor-fl-check" : "#",
                },
              },
              [
                _c("img", {
                  staticClass: "main-check-block__icon",
                  attrs: { src: "/images/proverka-posetitela.svg" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "main-check-block__text" }, [
                  _vm._v("Онлайн-проверка ФЛ"),
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "main-check-block__arrow",
                  attrs: { src: "/images/arrow-right.svg" },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                class: {
                  "main-check-block": true,
                  disabled: !_vm.hasAccessToAdditionalCheck,
                },
                attrs: {
                  href: _vm.hasAccessToAdditionalCheck
                    ? "/additional-check"
                    : "#",
                },
              },
              [
                _c("img", {
                  staticClass: "main-check-block__icon",
                  attrs: { src: "/images/dop-proverka.svg" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "main-check-block__text" }, [
                  _vm._v("Оффлайн-проверка"),
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "main-check-block__arrow",
                  attrs: { src: "/images/arrow-right.svg" },
                }),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showModal,
            expression: "showModal",
          },
        ],
        staticStyle: { "padding-bottom": "20px", display: "block" },
        attrs: { id: "screen-fast_search" },
      },
      [
        _c(
          "div",
          {
            staticClass: "cross",
            on: {
              click: function ($event) {
                _vm.showModal = false
              },
            },
          },
          [_c("i", { staticClass: "icon-close lnr lnr-cross" })]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "section-inner l-centered" }, [
          _c(
            "div",
            {
              staticClass: "search-request-modal",
              staticStyle: {
                "border-radius": "8px",
                "border-color": "#98bdd4",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "search-request-modal-submit",
                  staticStyle: { "line-height": "64px" },
                  on: { click: _vm.findHandler },
                },
                [_c("i", { staticClass: "lnr lnr-magnifier" })]
              ),
              _vm._v(" "),
              _vm.input
                ? _c(
                    "div",
                    {
                      staticClass: "search-request-modal-erase",
                      staticStyle: { display: "block" },
                      on: {
                        click: function ($event) {
                          _vm.input = ""
                        },
                      },
                    },
                    [_c("i", { staticClass: "lnr lnr-cross" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "search-request-modal-holder" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.input,
                      expression: "input",
                    },
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "ИНН, ОГРН, ОКПО, название или ФИО",
                    id: "search-request-modal",
                    autocomplete: "off",
                  },
                  domProps: { value: _vm.input },
                  on: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        $event.keyCode !== 13
                      ) {
                        return null
                      }
                      return _vm.findHandler.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.input = $event.target.value
                    },
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { "z-index": "2", "margin-top": "10px" } }, [
            _c(
              "div",
              { staticStyle: { "text-align": "center", "font-size": "12px" } },
              [
                _c(
                  "button",
                  {
                    staticClass: "dashed search-help-modal-toggle",
                    on: { click: _vm.toggleHelpCard },
                  },
                  [
                    _vm._v("\n                        Помощь "),
                    _c("i", {
                      staticClass: "fa fa-question-circle",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "text-align": "center", "margin-top": "10px" } },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showHelp,
                        expression: "showHelp",
                      },
                    ],
                    staticClass: "search-help-modal",
                    staticStyle: {
                      margin: "0 auto",
                      border: "solid 1px #ccc",
                      background: "#eee",
                      "border-radius": "6px",
                      padding: "15px",
                      "max-width": "30em",
                      "font-size": "14px",
                      display: "none",
                      "text-align": "left",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block",
                          "font-size": "16px",
                          "margin-bottom": "5px",
                        },
                      },
                      [
                        _vm._v(
                          "Поиск может осуществляться по следующим параметрам в любых сочетаниях:"
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block",
                          "font-weight": "700",
                        },
                      },
                      [_vm._v("Для поиска юридических лиц")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block",
                          "margin-bottom": "5px",
                        },
                      },
                      [
                        _vm._v(
                          "ИНН, ОГРН, ОКПО, краткое или полное название ЮЛ, ФИО руководителя ЮЛ (частично или полностью), ФИО совладельца ЮЛ (частично или полностью)."
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block",
                          "font-weight": "700",
                        },
                      },
                      [_vm._v("Для поиска физических лиц и ИП")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block",
                          "margin-bottom": "5px",
                        },
                      },
                      [
                        _vm._v(
                          "ИНН ФЛ, ОГРНИП, ФИО ИП/руководителя ЮЛ/совладельца ЮЛ (частично или полностью)."
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticStyle: { display: "inline-block" } }, [
                      _vm._v(
                        'Для поиска точного совпадения необходимо использовать кавычки " ". Например, "НУРАЛИЕВ БОРИС ГЕОРГИЕВИЧ", "ИНВЕСТ СТРОЙ ГРУПП"'
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { display: "none", "padding-top": "30px" },
              attrs: { id: "extended-modal-result" },
            },
            [
              _vm._v(
                "\n                Найдено больше 12 ЮЛ. Пожалуйста уточните запрос\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c("ul", {
            staticStyle: { padding: "30px 0 0 0", "font-weight": "400" },
            attrs: { id: "search-modal-result" },
          }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }